import { render, staticRenderFns } from "./ProfileUploader.vue?vue&type=template&id=40f395b9&scoped=true&"
import script from "./ProfileUploader.vue?vue&type=script&lang=js&"
export * from "./ProfileUploader.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUploader.vue?vue&type=style&index=0&id=40f395b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f395b9",
  null
  
)

export default component.exports